import { AxiosInstance } from 'axios';
import { AxiosClient, AxiosUtils } from 'api/AxiosClient/AxiosClient';
import { config } from 'config';
import * as Sentry from '@sentry/react';
import { User, InvoiceResponse } from 'types';
import { INVOICE_DOWN } from 'api/errors';

class Invoices {
  private readonly client: AxiosInstance;

  constructor() {
    this.client = AxiosClient.get({
      baseURL: config.URL_INVOICES,
    });
  }

  public async createTransaction(
    classifiedReference: string,
    user: User,
    productIds: string[],
  ): Promise<InvoiceResponse | undefined> {
    return this.client
      .post<InvoiceResponse>(
        'v2/transactions',
        {
          classifiedReference,
          productIds,
          paymentDate: new Date().toISOString(),
          customer: {
            firstName: user.firstName,
            lastName: user.lastName ?? '',
            address: {
              addressLine1: user.addresses?.[0].addressLine1,
              zipCode: user.addresses?.[0].zipCode,
              city: user.addresses?.[0].city,
            },
            site: user.site,
          },
          action: 'create',
        },
        {
          headers: AxiosClient.getAuthorizationHeader(),
        },
      )
      .then(r => r.data)
      .catch(r => {
        Sentry.captureException(r, {
          tags: {
            api: 'GA-invoices',
            endpoint: 'v2/transactions',
            ...AxiosUtils.enrichTags(r),
          },
        });
        return Promise.reject({ message: INVOICE_DOWN });
      });
  }
}

export const InvoicesService = new Invoices();
